import request from '@/libs/http/index'

// 开出设置---------
// 开出设置
export const dispensingDetail = params => {
  return request.get({
    url: `/clinic/settings-dispensing/get`,
    params,
  })
}
export const dispensingUpdate = data => {
  return request.put({
    url: `/clinic/settings-dispensing/update`,
    data,
  })
}
export const dispensingDefault = params => {
  return request.get({
    url: `/clinic/settings-dispensing/restore-default`,
    params,
  })
}

// 加工设置---------
// 加工设置
export const processingPage = params => {
  return request.get({
    url: `/clinic/settings-processing/page`,
    params,
  })
}
export const processingCreate = data => {
  return request.post({
    url: `/clinic/settings-processing/create-list`,
    data,
  })
}
export const processingDetail = params => {
  return request.get({
    url: `/clinic/settings-processing/get`,
    params,
  })
}
export const processingUpdate = data => {
  return request.put({
    url: `/clinic/settings-processing/update`,
    data,
  })
}
export const processingDelete = data => {
  return request.delete({
    url: `/clinic/settings-processing/delete?id=${data}`,
  })
}
export const processingDeleteList = params => {
  return request.delete({
    url: `/clinic/settings-processing/delete-list`,
    params,
  })
}
export const calculatePrice = params => {
  return request.get({
    url: `/clinic/settings-processing/calculate-price`,
    params,
  })
}
